import React from 'react';

const MongoDB_group = () => {
  return (
    <div>
      <h1>MongoDB_group Component</h1>
      <p>This is the MongoDB_group page.</p>
    </div>
  );
};

export default MongoDB_group;
